export default __webpack_public_path__ + "static/media/ico-solo.97458df5.svg";